import { render, staticRenderFns } from "./BookingPrestaVoucher.vue?vue&type=template&id=3064193e&scoped=true"
import script from "./BookingPrestaVoucher.vue?vue&type=script&lang=js"
export * from "./BookingPrestaVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3064193e",
  null
  
)

export default component.exports